import $ from "jquery"
import imagesLoaded from "imagesloaded"


$(function () {
	const $postsContainers = $('.posts');
	if ($postsContainers.length) {
		imagesLoaded.makeJQueryPlugin($);

		$postsContainers.each(function (index, e) {
			const $posts = $(this);
			const $postItems = $posts.find('.postItems');
			const $loadMore = $posts.find('.loadMore');
			const pageSize = $posts.data('pagesize') || 1;
			const useHistory = $posts.data('usehistory') == 1;
			const basePath = $posts.data('basepath');
			const baseTitle = document.title;
			const isGrid = $postItems.hasClass('grid');

			function resizeGridItem ($item, changeInitializedClass = true) {
				if (changeInitializedClass === true) {
					$postItems.removeClass('gridInitialized');
				}
				const rowHeight = parseInt($postItems.css('grid-auto-rows'));
				let rowGap = $postItems.css('grid-row-gap');
				if (rowGap === 'normal') {
					rowGap = 0;
				} else {
					rowGap = parseInt(rowGap);
				}

				let height = $item.find('.postInner img')[0].getBoundingClientRect().height;
				height = height > 0 ? height + rowGap : 0;
				const rowSpan = Math.ceil(height / (rowHeight + rowGap));

				if (rowSpan < 1) {
					$item.css('display', 'none');
				}

				$item.css('display', 'block');
				$item.css('grid-row-end', 'span ' + rowSpan);
				if (changeInitializedClass === true) {
					$postItems.addClass('gridInitialized');
				}
			}

			function resizeAllGridItems (changeInitializedClass = true) {
				$postItems.find('.post').each(function () {
					resizeGridItem($(this), changeInitializedClass);
				})
			}

			function resizeInstance (instance) {
				const item = instance.elements[0];
				resizeGridItem(item);
			}

			function checkLoadMore () {
				const itemCount = $postItems.find('.post').length;
				$loadMore.toggleClass('d-none', (itemCount % pageSize) !== 0);
				$postItems.data('hasmore', (itemCount % pageSize) === 0)
			}

			function loadAjax (filterData = null, reload = false) {
				$posts.data('lazyLoadEnabled', false);
				const url = $posts.data('ajaxurl');
				const additionalQuery = $posts.data('additionalquery') || '';
				const filterQuery = filterData ? '&' + filterData.toString() : '';
				let offset = reload ? 0 : (parseInt($posts.data('loadedcount') || 0));
				$.ajax({
					url: url + '?pagesize=' + pageSize + '&offset=' + offset + additionalQuery + filterQuery,
					beforeSend: function () {
						//Turn on loading state of submit button
						$loadMore.addClass('loading');
						$postItems.trigger('postAjaxLoadStart');
					},
				}).done(function (data, status, xhr) {
					if (xhr.status === 204) {
						$loadMore.addClass('d-none');
						$postItems.data('hasmore', 0)
					} else {
						if (reload) {
							closePosts()
							//history.pushState({}, baseTitle, basePath);
							$postItems.html('');
							$postItems.removeClass('hasOpened');
						}
						$postItems.append(data);
						$posts.data('loadedcount', $postItems.find(' > .post').length);

						if (isGrid) {
							initImagesLoaded($postItems);
						}
						checkLoadMore();
					}
				}).always(function (jqXHR) {
					$postItems.trigger('postAjaxLoaded');
					$loadMore.removeClass('loading');
					$posts.data('lazyLoadEnabled', true);
				})
			}

			function handlePath () {
				const relativePath = window.location.pathname.replace(basePath, '');
				closePosts();
				if (relativePath !== '') {
					const $item = $posts.find('.post[data-urlpath="' + relativePath + '"]').first();
					if ($item.length) {
						openPost($item);
					}
				}
			}

			function openPost ($item) {
				const title = $item.find('h2').first().text();

				$item.addClass('opened');
				$postItems.addClass('hasOpened');

				$item.trigger('postOpened');

				$([document.documentElement, document.body]).animate({
					scrollTop: $item.offset().top,
				}, 1000);

				document.title = title + ' | ' + baseTitle;

				resizeAllGridItems();
			}

			function closePosts () {
				$postItems.find('.post').removeClass('opened');
				$postItems.find('.post').trigger('postClosed');
				$postItems.removeClass('hasOpened');
				document.title = baseTitle;

				resizeAllGridItems();
			}

			function initImagesLoaded ($postItems) {
				$postItems.imagesLoaded()
					.always(function () {
						resizeAllGridItems();
					})
					.progress(function (instance, image) {
						const post = $(image.img).closest('.post');
						post.addClass('imageLoaded');
						resizeAllGridItems(false);
					});
			}

			if (isGrid) {
				resizeAllGridItems();
				$(window).on('resize', resizeAllGridItems);

				$postItems.on('postRefreshGrid', function () {
					resizeAllGridItems();
				});
				$postItems.on('postCloseAll', function () {
					closePosts();
				});
				initImagesLoaded($postItems);
			}

			if (useHistory) {
				$(window).on('popstate', function (event) {
					handlePath();
				});
			}

			$posts.on('postToggle', '.post', function (event) {
				const $item = $(event.target);
				if (parseInt($item.data('preventtoggle')) === 1) {
					return false;
				}
				const id = $item.data('id');
				const open = !$item.hasClass('opened');
				const hasOpenedAlready = $posts.find('.post.opened').length > 0;
				const title = $item.find('h2').first().text();
				const urlPath = basePath + $item.data('urlpath');

				if (useHistory) {
					if (open) {
						if (hasOpenedAlready) {
							history.replaceState({ id: id }, title, urlPath);
						} else {
							history.pushState({ id: id }, title, urlPath);
						}
					} else {
						history.back();
					}
					handlePath();
				} else {
					closePosts();
					if (open) {
						openPost($item);
					}
				}
			})

			if (isGrid) {
				$posts.on('click', '.postItems .moreLink a, .postItems .lessLink a', function (ev) {
					$(this).closest('.post').trigger('postToggle');
				});

				$posts.on('click', '.post:not(.opened) > .postInner > .imageWrapper, .post:not(.opened) .titleWrapper', function (ev) {
					$(this).closest('.post').trigger('postToggle');
				});
			}

			let $filterForm = null;
			if ($posts.data('filterform') && ($filterForm = $('#' + $posts.data('filterform'))).length) {
				let filterSearchTo = null;

				$filterForm.on('submit', function (ev) {
					loadAjax(new URLSearchParams(new FormData($filterForm[0])), true);
					ev.preventDefault();
					ev.stopPropagation();
					ev.stopImmediatePropagation();
				});
				$filterForm.find('input, select').on('change', function () {
					clearTimeout(filterSearchTo);
					$filterForm.trigger('submit');
				});

				$filterForm.find('input').on('keyup', function () {
					clearTimeout(filterSearchTo);
					filterSearchTo = setTimeout(function () {
						$filterForm.trigger('submit');
					}, 500);
				});

				$posts.on('click', 'a.loadMore', function () {
					loadAjax(new URLSearchParams(new FormData($filterForm[0])));
				});
				$postItems.on('postLoadAjax', function () {
					loadAjax(new URLSearchParams(new FormData($filterForm[0])));
				});

			} else {
				$posts.on('click', 'a.loadMore', function () {
					loadAjax();
				});
				$postItems.on('postLoadAjax', function () {
					loadAjax();
				});
			}

			if ($posts.find('.loadMore.noBtn').length) {
				$(window).on('scroll', function () {
					if ($loadMore.offset().top <= ($(window).scrollTop() + $(window).height()) && $posts.data('lazyLoadEnabled') && $postItems.data('hasmore')) {
						$postItems.trigger('postLoadAjax');
					}
				});
			}

			$posts.on('click', '.titleWrapper', function () {
				if ($(this).children('a').length) {
					$(this).children('a')[0].click();
				}
			});

			checkLoadMore();
		});
	}
});
